import { render, staticRenderFns } from "./UsuarioAdicionar.vue?vue&type=template&id=55692f2b&"
import script from "./UsuarioAdicionar.vue?vue&type=script&lang=js&"
export * from "./UsuarioAdicionar.vue?vue&type=script&lang=js&"
import style0 from "./usuario_adicionar.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports